var _style, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 32",
    style: {
      enableBackground: "new 0 0 40 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#285F74;}\n\t.st1{fill:#00A0AF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.51,2.95 24.99,8.03 20.79,8.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.51,2.95 24.99,8.03 27.52,11.38  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.51,11.38 24.99,16.45 20.79,16.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.51,11.38 24.99,16.45 27.52,19.81  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.77,8.04 18.25,13.11 14.05,13.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20.78,8.04 18.26,13.11 20.78,16.46  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14.05,13.12 11.53,18.19 7.33,18.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.05,13.12 11.53,18.19 14.06,21.55  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.77,16.46 18.25,21.53 14.05,21.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20.77,16.46 18.25,21.53 20.77,24.89  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.51,19.81 24.99,24.88 20.79,24.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.51,19.81 24.99,24.88 27.51,28.23  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6e7b4548dd761d2a4c51c1d49a541848.svg";
export { ForwardRef as ReactComponent };